// extracted by mini-css-extract-plugin
module.exports = {"error":"SecretsTable__error___f+LPv","awsLink":"SecretsTable__awsLink___9mB2u"};